import React from "react";

import { Link } from "react-router-dom";
// import CountUp from 'react-countup';

import avatar1 from "../assets/images/warr.png";
import avatar2 from "../assets/images/Uno-Minda.avif";
import avatar3 from "../assets/images/drdo.webp";
import avatar4 from "../assets/images/nrbb.jpg";
import avatar5 from "../assets/images/viran.png";
import avatar6 from "../assets/images/teaf.png";
import avatar7 from "../assets/images/macdermidenthone-shared.webp";
import avatar8 from "../assets/images/enar.jpg";
// import AmazonImage from '../assets/images/client/amazon.svg';
// import GoogleImage from '../assets/images/client/google.svg';
// import LenovoImage from '../assets/images/client/lenovo.svg';
// import PaypalImage from '../assets/images/client/paypal.svg';
// import ShopifyImage from '../assets/images/client/shopify.svg';
// import SpotifyImage from '../assets/images/client/spotify.svg';

export default function Team() {
    const team = [
      {
        name: "Wurth Industry",
        profile: avatar1,
       
      },
      {
        name: "Uno Minda",
        profile: avatar2,
       
      },
      {
        name: "DRDO",
        profile: avatar3,
       
      },
      {
        name: "NRB Bearings",
        profile: avatar4,
       
      },
      {
        name: "Virinchi Teknik",
        profile: avatar5,
       
      },
      {
        name: "Tefcon",
        profile: avatar6,
     
      },
      {
        name: "Macdermid Enthone",
        profile: avatar7,
        
      },
      {
        name: "Enertech",
        profile: avatar8,
      
      },
    ];

    return (
      <>
        <section
          className="relative  py- bg-gray-50 dark:bg-slate-800"
          id="team"
        >
          <div className="container">
            <div className="grid grid-cols-1 pb-8 text-center">
              <h6 className="text-[#69A41D] text-base text-[16px] font-medium uppercase mt-[95px] mb-2"></h6>
              <h3 className="mb-4 mt-1 text-[40px] font-medium text-[#18443A]">
                Our Clients
              </h3>

              <p className="text-[#5A7A6D] text-[18px] dark:text-slate-300 max-w-xl mx-auto mb-16">
                Dedicated Experts Behind Our Innovative Wooden Packaging
                Solutions.
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-4 md:grid-cols-2 gap-6 mt-8">
              {team.map((member, index) => (
                <div
                  key={index}
                  className="relative rounded-md shadow-lg overflow-hidden group"
                >
                  <img
                    src={member.profile}
                    className="group-hover:origin-center group-hover:scale-105 transition duration-500"
                    alt=""
                  />
                  <div className="transition duration-300 group-hover:scale-105"></div>
                  {/* <ul className="list-none absolute z-10 opacity-0 group-hover:opacity-100 top-4 end-4 mb-0 transition-all duration-500">
                                    <li className="mb-1"><Link to="#" className="btn bg-orange-600 hover:bg-orange-700 border-orange-600 hover:border-orange-700 text-white btn-icon btn-sm rounded-full"><i className="uil uil-facebook-f"></i></Link></li>
                                    <li className="mb-1"><Link to="#" className="btn bg-orange-600 hover:bg-orange-700 border-orange-600 hover:border-orange-700 text-white btn-icon btn-sm rounded-full"><i className="uil uil-instagram"></i></Link></li>
                                    <li className="mb-1"><Link to="#" className="btn bg-orange-600 hover:bg-orange-700 border-orange-600 hover:border-orange-700 text-white btn-icon btn-sm rounded-full"><i className="uil uil-twitter"></i></Link></li>
                                </ul> */}

                  <div className="content absolute start-4 end-4 bottom-4 bg-white dark:bg-slate-900 opacity-0 group-hover:opacity-100 p-4 rounded-md text-center transition-all duration-500">
                    <Link
                      to="#"
                      className="h5 text-md dark:text-white hover:text-[#69A41D] dark:hover:text-[#69A41D] font-medium"
                    >
                      {member.name}
                    </Link>
                    <h6 className="text-slate-400 dark:text-slate-300 mb-0 font-light">
                      {member.designation}
                    </h6>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* 
                <div className="container mt-12">
                    <div className="grid grid-cols-2 md:grid-cols-4">
                        <div className="counter-box position-relative text-center">
                            <h3 className="font-medium text-3xl mb-2 dark:text-white">
                                <CountUp
                                    start={3}
                                    className="counter-value"
                                    end={40}
                                    duration={2.75} />+</h3>
                            <span className="counter-head text-slate-400 dark:text-slate-300">Projects</span>
                        </div>

                        <div className="counter-box position-relative text-center">
                            <h3 className="font-medium text-3xl mb-2 dark:text-white">
                                <CountUp
                                    start={1}
                                    className="counter-value"
                                    end={200}
                                    duration={2.75} />+</h3>
                            <span className="counter-head text-slate-400 dark:text-slate-300">Clients</span>
                        </div>

                        <div className="counter-box position-relative text-center">
                            <h3 className="font-medium text-3xl mb-2 dark:text-white">
                                <CountUp
                                    start={200}
                                    className="counter-value"
                                    end={457}
                                    duration={2.75} />
                                K</h3>
                            <span className="counter-head text-slate-400 dark:text-slate-300">Members</span>
                        </div>

                        <div className="counter-box position-relative text-center">
                            <h3 className="font-medium text-3xl mb-2 dark:text-white">
                                <CountUp
                                    start={100}
                                    className="counter-value"
                                    end={150}
                                    duration={2.75} />
                                +</h3>
                            <span className="counter-head text-slate-400 dark:text-slate-300">Employee</span>
                        </div>
                    </div>
                </div> */}

          {/* <div className="container mt-12">
                    <div className="grid md:grid-cols-6 grid-cols-2 justify-center gap-8">
                        <div className="mx-auto">
                            <img src={AmazonImage} className="h-[25px]" alt="" />
                        </div>

                        <div className="mx-auto">
                            <img src={GoogleImage} className="h-[25px]" alt="" />
                        </div>

                        <div className="mx-auto">
                            <img src={LenovoImage} className="h-[25px]" alt="" />
                        </div>

                        <div className="mx-auto">
                            <img src={PaypalImage} className="h-[25px]" alt="" />
                        </div>

                        <div className="mx-auto">
                            <img src={ShopifyImage} className="h-[25px]" alt="" />
                        </div>

                        <div className="mx-auto">
                            <img src={SpotifyImage} className="h-[25px]" alt="" />
                        </div>
                    </div>
                </div> */}
          {/* <!--end container--> */}
        </section>
      </>
    );

}


